import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Controller } from 'react-hook-form';
import { useZodFormContext } from './context.js';
import { readMeta } from './lib/read-meta.js';
import { resolveSchemaAt } from './lib/walk-schema.js';
import { matchWidget } from './lib/match-widget.js';
export function ZodField(props) {
    const { name, label, description, hint, as, render, readonly, disabled, schema: schemaProp, ...rest } = props;
    const ctx = useZodFormContext();
    const schema = schemaProp ?? resolveSchemaAt(ctx.schema, name);
    if (!schema) {
        if (typeof process !== 'undefined' && process.env?.NODE_ENV !== 'production') {
            console.warn(`[ZodField] Could not resolve schema at path "${name}".`);
        }
        return _jsx(_Fragment, {});
    }
    const rawMeta = readMeta(schema);
    const override = ctx.fieldMetaOverrides[name] ?? {};
    const meta = { ...rawMeta, ...override };
    const widget = as
        ? { id: 'as', priority: 0, matches: () => true, component: as }
        : matchWidget(ctx.widgets, schema, meta);
    const Component = widget?.component;
    const effectiveReadonly = readonly ?? ctx.readonly ?? meta.readonly ?? false;
    return (_jsx(Controller
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    , { 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        control: ctx.form.control, name: name, render: ({ field, fieldState }) => {
            if (render) {
                return _jsx(_Fragment, { children: render({ field, fieldState, meta, schema }) });
            }
            if (!Component) {
                return _jsx(_Fragment, {});
            }
            const extra = { ...rest };
            if (label !== undefined)
                extra.label = label;
            else if (meta.label !== undefined)
                extra.label = meta.label;
            if (description !== undefined)
                extra.description = description;
            else if (meta.description !== undefined)
                extra.description = meta.description;
            if (hint !== undefined)
                extra.hint = hint;
            else if (meta.hint !== undefined)
                extra.hint = meta.hint;
            if (disabled !== undefined)
                extra.disabled = disabled;
            return (_jsx(Component, { field: field, fieldState: fieldState, schema: schema, meta: meta, readonly: effectiveReadonly, name: name, ...extra }));
        } }));
}
//# sourceMappingURL=zod-field.js.map